export function safelyParse<T>(
  json: string | null | undefined,
): T | null | undefined {
  try {
    return JSON.parse(json || "");
  } catch (e) {
    return null;
  }
}

/**
 * Serializes a value for embedding in an inline script tag. Escapes `<` to
 * prevent XSS via `</script>` injection, and U+2028/U+2029 which are valid in
 * JSON but break `JSON.parse` in JavaScript.
 */
export const toInlineJson = (value: unknown): string =>
  JSON.stringify(value)
    .replace(/</g, "\\u003c")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
